import './Newsletter.css';
import React, { useState } from 'react';
import { trackCustomEvent } from 'gatsby-plugin-google-analytics';
import addToMailchimp from 'gatsby-plugin-mailchimp';

import { Link } from 'gatsby';
function EmailCollector(props) {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(false);
  const [errorStatement, setErrorStatement] = useState('');

  function errorHandling(data) {
    console.log(data);
    setError(true);
  }

  const handleSubmit = () => {
    // Validation
    if (!email) {
      setError(true);
      setErrorStatement('email_required');
    } else if (email) {
      let lastAtPos = email.lastIndexOf('@');
      let lastDotPos = email.lastIndexOf('.');

      if (
        !(
          lastAtPos < lastDotPos &&
          lastAtPos > 0 &&
          email.indexOf('@@') == -1 &&
          lastDotPos > 2 &&
          email.length - lastDotPos > 2
        )
      ) {
        setError(true);
        setErrorStatement('invalid_email');
      } else {
        // Mailchip Add
        addToMailchimp(email).then(data => {
          if (data.result == 'error') {
            errorHandling(data);
            setErrorStatement('already_subscribed');
          } else {
            trackCustomEvent({
              category: 'Newsletter',
              action: 'Click',
              label: `Newsletter Click`,
            });
            setSubmitted(true);
          }
        });
      }
    }
  };

  return (
    <>
      {submitted ? (
        <>
           <div>
             <div className=" section-title section-title-blue text-align-center">
         
             <h6> Welcome to the BizDamn Community</h6>
            <br />
            <a style={{ color: 'white' }} className="premium-btn-black" href={props.link}>
              Your Template
            </a>
          </div>
          <div className="justify-content">
            <p>
              <b>
                {' '}
                If you’re looking for Starting an Online Business or taking existing one Online.{' '}
              </b>
              <br />
            </p>
            <Link
              to="/consultancy"
              mdb-toggle="tooltip"
              title="This E-book contains 103 Online Business Ideas categorised into 7 major categories with all resources you need to get started"
            >
              We can help you to Kickstart Your Business Online
            </Link>
            <ul>
              <li>
                <Link to="/website-packages">Your Wordpress Blog</Link>
              </li>
              <li>
                <Link to="/website-packages">Add Extra Features to Your Website</Link>
              </li>
              <li>
                <Link to="/website-packages">Get an Online E-Commerce Store</Link>
              </li>
              <li>
                <Link to="/website-packages">Get a Landing Page that Converts</Link>
              </li>
            </ul>
          </div>
          </div>
        </>
      ) : errorStatement == 'invalid_email' ? (
        <>
         
          <div className="mt-5">
          <div className="section-title section-title-blue text-align-center">
          
            <p>
             <b>Please Enter a valid Email</b>
            </p>
          </div>
            <div
              className="wrap-input100 validate-input"
              data-validate="Valid email is required: ex@abc.xyz"
            >
              <input
                required
                onChange={e => setEmail(e.target.value)}
                className="input100"
                type="text"
                placeholder="Email"
              />
              <span className="focus-input100"></span>
              <span className="symbol-input100">
                <i className="fa fa-envelope" aria-hidden="true"></i>
              </span>
            </div>

            <div className="container-login100-form-btn">
              <button onClick={() => handleSubmit()} type="submit" className="premium-btn-black">
                <span>Grab Your Template Now!</span>
              </button>
            </div>
          </div>
        </>
      ) : errorStatement == 'email_required' ? (
        <>
         
          <div className="mt-5">
          <div className="section-title section-title-blue text-align-center">
           
            <p>
             <b>Email address is Required</b>
            </p>
          </div>
            <div
              className="wrap-input100 validate-input"
              data-validate="Valid email is required: ex@abc.xyz"
            >
              <input
                required
                onChange={e => setEmail(e.target.value)}
                className="input100"
                type="text"
                placeholder="Email"
              />
              <span className="focus-input100"></span>
              <span className="symbol-input100">
                <i className="fa fa-envelope" aria-hidden="true"></i>
              </span>
            </div>

            <div className="container-login100-form-btn">
              <button onClick={() => handleSubmit()} type="submit" className="premium-btn-black">
                <span>Grab Your Template Now!</span>
              </button>
            </div>
          </div>
        </>
      ) : errorStatement == 'already_subscribed' ? (
        <>
        <div>
             <div className=" section-title section-title-blue text-align-center">
            <p>
              🤔 It looks like you are already a part of <b>BizDamn Community</b>
            </p>
            <p>
              In other words, you’re already awesome and <b>have access to all our Graphic Templates</b>
            </p>
            <br />
            <a style={{ color: 'white' }} className="premium-btn-black" href={props.link}>
              Your Template
            </a>
          </div>
          <div className="justify-content">
            <p>
              <b>
                {' '}
                If you’re looking for Starting an Online Business or taking existing one Online.{' '}
              </b>
              <br />
            </p>
            <Link
              to="/consultancy"
              mdb-toggle="tooltip"
              title="This E-book contains 103 Online Business Ideas categorised into 7 major categories with all resources you need to get started"
            >
     We build Websites that Convert & Increase Sales
            </Link>
            <p>Grab your Package Now!!</p>
            <ul>
              <li>
                <Link to="/web-development-services">Landing Page that Converts</Link>
              </li>
              <li>
                <Link to="/web-development-services">SEO Optimized Blog</Link>
              </li>
              <li>
                <Link to="/web-development-services">E-Commerce Website</Link>
              </li>
              <li>
                <Link to="/web-development-services">BestSeller Book Launch Landing Page</Link>
              </li>
 
            </ul>
          </div>
          </div>
        </>
      ) : (
        <>
          <div className="mt-5">
            <div
              className="wrap-input100 validate-input"
              data-validate="Valid email is required: ex@abc.xyz"
            >
              <input
                required
                onChange={e => setEmail(e.target.value)}
                className="input100"
                type="text"
                placeholder="Email"
              />
              <span className="focus-input100"></span>
              <span className="symbol-input100">
                <i className="fa fa-envelope" aria-hidden="true"></i>
              </span>
            </div>

            <div className="container-login100-form-btn">
              <button onClick={() => handleSubmit()} type="submit" className="premium-btn-black">
                <span>Grab Your Template Now!</span>
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default EmailCollector;
